export default __webpack_public_path__ + "static/media/06_Livingroom-Interior-Architecture-EschweilerPhotography_21A0003-HDR2.41ea1abe.jpg";